import {
  Customer,
  Invoice,
  LandlordUser,
  MailConfigCustomer,
  Pagination
} from '@ui/shared/model';

import { ActionState, ActionStateCreator } from '@ui/legacy-lib';

import { CustomerPaymentsOverviewItem } from '../queries/gql-queries';

import {
  CANCEL_INVOICE,
  CANCEL_INVOICE_FAIL,
  CANCEL_INVOICE_SUCCESS,
  CHANGE_USER_ENABLED,
  CHANGE_USER_ENABLED_FAIL,
  CHANGE_USER_ENABLED_SUCCESS,
  ENABLE_EXTERNAL_PRICING_SUCCESS,
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_FAIL,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMER_BY_ID,
  FETCH_CUSTOMER_BY_ID_FAIL,
  FETCH_CUSTOMER_BY_ID_SUCCESS,
  FETCH_INVOICES,
  FETCH_INVOICES_FAIL,
  FETCH_INVOICES_SUCCESS,
  FETCH_INVOICE_BY_ID,
  FETCH_INVOICE_BY_ID_FAIL,
  FETCH_INVOICE_BY_ID_SUCCESS,
  FETCH_MAIL_CONFIG_CUSTOMER_SUCCESS,
  FETCH_PAYMENTS_OVERVIEW,
  FETCH_PAYMENTS_OVERVIEW_FAIL,
  FETCH_PAYMENTS_OVERVIEW_SUCCESS,
  FETCH_USERS,
  FETCH_USERS_FAIL,
  FETCH_USERS_SUCCESS,
  IMPERSONATE_USER,
  IMPERSONATE_USER_FAIL,
  IMPERSONATE_USER_SUCCESS,
  LandlordAction
} from './landlord.actions';

export interface LandlordState {
  usersData: LandlordUser[];
  customersData: Customer[];
  invoicesData: Invoice[];
  paymentsData: CustomerPaymentsOverviewItem[];
  landlordActionState: ActionState;
  pagination: Pagination;
  mailConfigCustomer: MailConfigCustomer;
}

export const initialState: LandlordState = {
  usersData: [],
  customersData: [],
  invoicesData: [],
  paymentsData: [],
  landlordActionState: ActionStateCreator.create(),
  pagination: null,
  mailConfigCustomer: null
};

export function reducer(
  state = initialState,
  action: LandlordAction
): LandlordState {
  switch (action.type) {
    case FETCH_USERS_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        usersData: action.data,
        pagination: action.pagination
      };
    }

    case FETCH_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        customersData: action.data,
        pagination: action.pagination
      };
    }

    case FETCH_INVOICES_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        invoicesData: action.data,
        pagination: action.pagination
      };
    }

    case FETCH_PAYMENTS_OVERVIEW_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        paymentsData: action.data
      };
    }

    case CHANGE_USER_ENABLED_SUCCESS: {
      state.usersData.map(user => {
        if (user.id === action.data.id) user.enabled = action.data.enabled;
      });

      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess()
      };
    }

    case FETCH_CUSTOMER_BY_ID_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        customersData: action.data
      };
    }

    case FETCH_INVOICE_BY_ID_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess(),
        invoicesData: action.data
      };
    }

    case IMPERSONATE_USER_SUCCESS:
    case CANCEL_INVOICE_SUCCESS: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onSuccess()
      };
    }

    case FETCH_USERS:
    case FETCH_CUSTOMERS:
    case FETCH_INVOICES:
    case FETCH_PAYMENTS_OVERVIEW:
    case CHANGE_USER_ENABLED:
    case FETCH_CUSTOMER_BY_ID:
    case FETCH_INVOICE_BY_ID:
    case IMPERSONATE_USER:
    case CANCEL_INVOICE: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onStart()
      };
    }

    case ENABLE_EXTERNAL_PRICING_SUCCESS: {
      const customersData = state.customersData.map(customer => {
        if (customer.id === action.id) {
          return {
            ...customer,
            externalPricing: action.enable
          };
        }
        return customer;
      });

      return {
        ...state,
        customersData
      };
    }

    case FETCH_USERS_FAIL:
    case FETCH_CUSTOMERS_FAIL:
    case FETCH_INVOICES_FAIL:
    case FETCH_PAYMENTS_OVERVIEW_FAIL:
    case CHANGE_USER_ENABLED_FAIL:
    case FETCH_CUSTOMER_BY_ID_FAIL:
    case FETCH_INVOICE_BY_ID_FAIL:
    case IMPERSONATE_USER_FAIL:
    case CANCEL_INVOICE_FAIL: {
      return {
        ...state,
        landlordActionState: ActionStateCreator.onError(action.error)
      };
    }

    case FETCH_MAIL_CONFIG_CUSTOMER_SUCCESS: {
      return {
        ...state,
        mailConfigCustomer: action.mailConfigCustomer
      };
    }

    default:
      return state;
  }
}

export const getMailConfigCustomer = (state: LandlordState) =>
  state.mailConfigCustomer;
export const getLandlordUsersData = (state: LandlordState) => state.usersData;
export const getLandlordCustomersData = (state: LandlordState) =>
  state.customersData;
export const getLandlordInvoicesData = (state: LandlordState) =>
  state.invoicesData;
export const getLandlordPaymentsData = (state: LandlordState) =>
  state.paymentsData;
export const getLandlordActionState = (state: LandlordState) =>
  state.landlordActionState;
export const getPagination = (state: LandlordState) => state.pagination;
